import { create } from 'zustand';
import { loadJson, saveJson } from '@/lib/persist';
import type { Formation } from '@/swarm/formations';

const STORAGE_KEY = 'fabricos.swarm.v1';

interface SwarmStore {
  formation: Formation;
  spacing: number;
  altStagger: number;
  setFormation: (f: Formation) => void;
  setSpacing: (m: number) => void;
  setAltStagger: (m: number) => void;
}

interface Persisted {
  formation: Formation;
  spacing: number;
  altStagger: number;
}

const DEFAULTS: Persisted = { formation: 'line', spacing: 8, altStagger: 2 };

function persist(patch: Partial<Persisted>, prev: SwarmStore) {
  const next: Persisted = {
    formation: patch.formation ?? prev.formation,
    spacing: patch.spacing ?? prev.spacing,
    altStagger: patch.altStagger ?? prev.altStagger,
  };
  saveJson(STORAGE_KEY, next);
}

export const useSwarm = create<SwarmStore>((set, get) => {
  const initial = loadJson<Persisted>(STORAGE_KEY, DEFAULTS);
  return {
    ...initial,
    setFormation: (formation) => {
      set({ formation });
      persist({ formation }, get());
    },
    setSpacing: (spacing) => {
      set({ spacing });
      persist({ spacing }, get());
    },
    setAltStagger: (altStagger) => {
      set({ altStagger });
      persist({ altStagger }, get());
    },
  };
});
